<img
  *ngIf="!cancelar"
  type="button"
  class="buttonDelecao"
  (click)="mostrarModal()"
  src="assets/images/icons/trash.svg"
/>
<button
  *ngIf="cancelar"
  type="button"
  class="button-cancelar"
  (click)="mostrarModal()"
>
  Cancelar Reunião
</button>
<ng-container *ngIf="mostrar">
  <div class="custom-modal-bottom">
    <ng-content></ng-content>

    <nav class="div-botoes">
      <a class="btn btn-cancelar" (click)="toggle()">Não</a>
      <a class="btn btn-salvar" (click)="deleteRequest.emit($event); toggle()"
        >Sim</a
      >
    </nav>
  </div>
  <div (click)="toggle()" class="custom-overlay-bottom"></div>
</ng-container>
